import { register } from "react-native-bundle-splitter";
export { default as PropertySelectCard } from "./components/PropertySelectCard/PropertySelectCard";
export default register({ loader: () => import("./MyProperties") });
